import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EmployeeOptionsStatement } from '../../../options/components/EmployeeOptionsStatement';
import { EmployeeOptionsStatement as EmployeeOptionsData } from '../../../options/types/employee-statement';
import { EmployeeOptionsService } from '../../../options/services/employee-options-service';
import PendingExerciseRequests from './PendingExerciseRequests';
import { Row, Col } from 'react-bootstrap';

interface EmployeeStmtDetailsNewProps {
  employeeId: number;
}

const EmployeeStmtDetailsNew = ({ employeeId }: EmployeeStmtDetailsNewProps) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [optionsData, setOptionsData] = useState<EmployeeOptionsData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchEmployeeStatement() {
      try {
        setIsLoading(true);
        setError(null);

        // Fetch activity statement (unfiltered - contains all data needed)
        const data = await EmployeeOptionsService.getEmployeeOptionsForActivity(employeeId);
        setOptionsData(data);
      } catch (err) {
        console.error('Error fetching employee statement:', err);
        setError(err instanceof Error ? err.message : 'Failed to load employee options');
      } finally {
        setIsLoading(false);
      }
    }

    fetchEmployeeStatement();
  }, [employeeId]);

  const handleExerciseClick = () => {
    history.push(`/options/employees/${employeeId}/exercise`);
  };

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Error loading employee options: {error}
      </div>
    );
  }

  return (
    <>
      {/* Pending Exercise Requests - show above the main statement */}
      {!isLoading && (
        <Row className="mb-3">
          <Col>
            <PendingExerciseRequests employeeId={employeeId} />
          </Col>
        </Row>
      )}

      {/* Main Employee Options Statement */}
      <EmployeeOptionsStatement
        data={optionsData!}
        isLoading={isLoading}
        onExerciseClick={handleExerciseClick}
        showEmployeeLabel={true}
      />
    </>
  );
};

export default EmployeeStmtDetailsNew;